/// <reference path="../definitions/QueryTs.d.ts" />

interface IQueryCanvasDimensions {
    width: number,
    height: number,
    scale: number
}

interface IQueryCanvasFont {
    fontFamily: string;
    fontStyle?: string;
    fontWeight?: number;
    url: string;
}

class QueryCanvas
    extends QueryElement<HTMLCanvasElement> {

    private _styleSheets: string[]
        = [];

    constructor() {
        super(document.createElement("CANVAS") as HTMLCanvasElement)

        let elem = this.get();
        if(elem === null)
            return;

        elem.width = 300;
        elem.height = 300;
    }
    async addFont(font: IQueryCanvasFont) {
        let request = await new QueryRequest(font.url, { useCache: true }).request();
        let base64 = await QueryCanvasHelper.blobToBase64(await request.blob());

        let addStyle = "";

        addStyle += `@font-face{font-family:'${font.fontFamily}';`
        if(font.fontStyle !== null)
            addStyle += `font-style:${font.fontStyle};`
        if(font.fontWeight !== null)
            addStyle += `font-weight:${font.fontWeight};`
        addStyle += `src: url(${base64});}`;

        this._styleSheets.push(addStyle);
        
        return this;
    }
    async addStyleSheet(src: string) {
        let request = await new QueryRequest(src).request();
        this._styleSheets.push(await request.text());
        
        return this;
    }
    async addStyle(style: string) {
        this._styleSheets.push(style);
        return this;
    }

    async set(element: IQueryElement, dimensions: IQueryCanvasDimensions) {
        
        let elem = this.get();
        let displayElem = element.get();
        if(elem === null || displayElem === null)
            return;

        
        elem.width = dimensions.width * dimensions.scale;
        elem.height = dimensions.height * dimensions.scale;

        let serializer = new XMLSerializer();
        let serialized = serializer.serializeToString(displayElem);

        let styleSheets = this._styleSheets
            .map(a => `<style>${a}</style>`)
            .join("");
        let startObj = `
        <svg xmlns="http://www.w3.org/2000/svg" width="${dimensions.width}" height="${dimensions.height}" font-size="16px">
        <foreignObject x="0" y="0" width="${dimensions.width}" height="${dimensions.height}">
            <html xmlns="http://www.w3.org/1999/xhtml">
                <head>${styleSheets}</head>
                <body><div id='containers'>${serialized}</div></body>
            </html>
        </foreignObject>
        </svg>`;

        let svg = new Blob([startObj], {type: 'image/svg+xml;charset=utf-8'});
        let url = window.URL.createObjectURL(svg);
        let ctx = elem.getContext('2d');

        if(ctx === null)
            return;

        try {
            let img = await QueryCanvasHelper.loadImage(url, dimensions.width, dimensions.height);
            ctx.drawImage(img, 0, 0, elem.width, elem.height);
        } catch {
            
        }
        window.URL.revokeObjectURL(url);
    }
}